import React, { Component } from "react";
import { ButtonToolbar, Table, Grid } from 'react-bootstrap';

import { PropTypes } from 'prop-types';
import { LoadingSpinner } from '../../LoadingSpinner';
import { SortIndicator } from '../../SortIndicator';
import { PaginationBuilder } from '../../PaginationBuilder';
import { TableButton } from '../../TableButton';
import { SearchHelper } from '../../helpers/SearchHelper';
import { PaginationHelper } from '../../helpers/PaginationHelper';

export class LinesDraft extends Component {
    static contextTypes = {
        edition: PropTypes.object
    }
    
    constructor(props) {
        super(props);

        this.state = {
            render: {
                sort: {
                    property: "code",
                    type: "ascending"
                }
            }
        }
    }

    // -----------------------

    onChangeSort(property) {
        const { render } = this.state;

        render.sort.type = render.sort.property === property && "ascending" === render.sort.type ? "descending" : "ascending";
        render.sort.property = property;

        this.setState({
            render: render
        });
    }

    // -----------------------

    sortLines(sort, a, b) {
        let aValue = a[sort.property];
        let bValue = b[sort.property];

        if ("object" === typeof aValue) {
            aValue = undefined !== aValue.left ? aValue.left : aValue.right;
        }

        if ("object" === typeof bValue) {
            bValue = undefined !== bValue.left ? bValue.left : bValue.right;
        }

        if(aValue === bValue) {
            return 0;
        }

        const output = aValue < bValue ? -1 : 1;

        if("descending" === sort.type) {
            return output * -1;
        }

        return output;
    }

    // -----------------------

    renderColor(lineColor, color) {
        if (undefined === lineColor || null === lineColor) {
            return null;
        }

        if (!lineColor.hasOwnProperty(color)) {
            return null;
        }

        return (
            <span className="span-colors"
                style={
                    { backgroundColor: `rgba(${lineColor[color].r}, ${lineColor[color].g}, ${lineColor[color].b}, ${lineColor[color].a})` }
                }
            />
        );
    }

    renderLoading(isLoading) {
        if (isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderSortIndicator(property, sort) {
        if(property !== sort.property) {
            return (
                <SortIndicator order="none" />
            );
        }

        return (
            <SortIndicator order={sort.type} />
        );
    }

    render() {
        const { edition } = this.context;

        if (null === edition || undefined === edition) {
            return null;
        }

        const { render } = this.state;
        const { lines, isLoading, currentPage, elementsPerPage, filter } = this.props;

        const linesFiltered = SearchHelper.search({
            filter: filter,
            data: lines,
            fields: ["code", "externalCode", "goName", "returnName"]
        });

        const totalPages = PaginationHelper.getTotalPages(linesFiltered.length, elementsPerPage);
        const activePage = totalPages < currentPage ? totalPages : currentPage;
        const linesToRender = linesFiltered.sort((a, b) => this.sortLines(render.sort, a, b))
            .slice((activePage - 1) * elementsPerPage, activePage * elementsPerPage);

        return (
            <Grid fluid className="table-small-screens">
                <div className="table-loading">
                    <Table responsive striped hover >
                        <thead>
                            <tr>
                                <th className="width-10p sortable" onClick={() => this.onChangeSort("code")}>Código {this.renderSortIndicator("code", render.sort)}</th>
                                <th className="width-10p sortable" onClick={() => this.onChangeSort("externalCode")}>Código Externo {this.renderSortIndicator("externalCode", render.sort)}</th>
                                <th className="width-20p sortable" onClick={() => this.onChangeSort("goName")}>Nome de Ida {this.renderSortIndicator("goName", render.sort)}</th>
                                <th className="width-20p sortable" onClick={() => this.onChangeSort("returnName")}>Nome de Volta {this.renderSortIndicator("returnName", render.sort)}</th>
                                <th className="width-10p">Cor Fundo </th>
                                <th className="width-10p">Cor Texto</th>
                                <th className="width-10p">Edição</th>
                                <th className="width-10p">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                linesToRender.map((line, idx) =>
                                    <tr key={`line-${idx}`}>
                                        <td>{line.code}</td>
                                        <td>{line.externalCode}</td>
                                        <td>{line.goName}</td>
                                        <td>{line.returnName}</td>
                                        <td>{this.renderColor(line.lineColor, "backColor")}</td>
                                        <td>{this.renderColor(line.lineColor, "foreColor")}</td>
                                        <td>{edition.getDraftNetworkEditionName(line.networkEdition)}</td>
                                        <td>
                                            <ButtonToolbar className="pull-right">
                                                <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.props.onEditClick(line)} />
                                                <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.props.onDeleteClick(line)} />
                                            </ButtonToolbar>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table >
                    <PaginationBuilder
                        currentPage={currentPage}
                        elementsPerPage={elementsPerPage}
                        dataLength={linesFiltered.length}
                        onChangePage={(a) => this.props.onChangePage(a)}
                        onChangeElementsPerPage={(a) => this.props.onChangeElementsPerPage(a)} />

                    {this.renderLoading(isLoading)}
                </div>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/lines/LinesDraft.js